import moment from 'moment';
import { rqx } from '../../core/request/API';
import { domain, env } from '../../core/Env';

// export const BookingUbr = async (compID, pa, ainfo) => {
//     let l = { location: JSON.parse(pa).inputs.logo.link }
//     let bp = { location: JSON.parse(pa).inputs.bg.link }
//     let fi = { location: JSON.parse(pa).inputs.featured_image.link }
//     const time_selected = JSON.parse(pa).inputs.time.filter(item => item.checked).map(item => ({ id: item.id, checked: item.checked }));

//     const b = {
//         company_id: compID,
//         id: JSON.parse(pa).pid,
//         package_name: JSON.parse(pa).inputs.package_name.value,
//         promo_name: JSON.parse(pa).inputs.promo_name.value,
//         start_date: moment(JSON.parse(pa).inputs.start_date.value).format('YYYY-MM-DD'),
//         end_date: moment(JSON.parse(pa).inputs.end_date.value).format('YYYY-MM-DD'),
//         link: JSON.parse(pa).inputs.buttons.first.link,
//         status: JSON.parse(pa).submit.type,
//         user_id: window.atob(ainfo.aid).split('_').pop(),
//         title: JSON.parse(pa).inputs.title.value,
//         designs: [{
//             logo: l.location,
//             featured_image: fi.location,
//             background_photo: bp.location,
//         }],
//         buttons: [{ label: JSON.parse(pa).inputs.buttons.first.label, link: JSON.parse(pa).inputs.buttons.first.link, button_color: '#F8A608' }],
//         location: JSON.parse(pa).inputs.location.value,
//         contact_number: JSON.parse(pa).inputs.contact_num.value,
//         fb_page: JSON.parse(pa).inputs.fb.value,
//         inclusion_name: JSON.parse(pa).inputs.inclusions.map((i) => {
//             if (JSON.parse(pa).inputs.method === 'create') {
//                 return i.value
//             }
//             return i.value
//         }),
//         rate: JSON.parse(pa).inputs.rate.value,
//         discount: JSON.parse(pa).inputs.discount.value,
//         total_rate: (parseFloat(JSON.parse(pa).inputs.rate.value) - (parseFloat(JSON.parse(pa).inputs.rate.value) * (parseFloat(JSON.parse(pa).inputs.discount.value) / 100))).toFixed(2),
//         number_of_days: JSON.parse(pa).inputs.days_per_promo.value,
//         active: 1,
//         accept_partial: JSON.parse(pa).inputs.partial.toggled ? 1 : 0,
//         partial_amount: JSON.parse(pa).inputs.partial.toggled ? JSON.parse(pa).inputs.partial.value : '',
//         booking_time: time_selected.length > 0 ? time_selected : null
//     }
//     const s = await rqx.post(`<<tool>>/${env()}/booking/promo/${JSON.parse(pa).method}`, b)
//     return s
// }

export const LoyaltyUbr = async (compID, pa, ainfo) => {
    let body = {
        id: JSON.parse(pa).id,
        series_num: "PTNG-00000001",
        name: JSON.parse(pa).name,
        points: JSON.parse(pa).points,
        points_to_earn: JSON.parse(pa).points_to_earn,
        free: JSON.parse(pa).free,
        promo_start: JSON.parse(pa).promo_start,
        promo_end: JSON.parse(pa).promo_end,
        active: JSON.parse(pa).active === true ? 1 : 0,
        user_id: parseInt(window.atob(ainfo.aid).split('_')[1]),
        company_id: compID
    }
    let requestData = await rqx.post(`<<tool>>/${env()}/promos/createpointing`, body)

    return requestData
}

export const ProductUbr = async (compID, pa, ainfo) => {
    const userId = parseInt(window.atob(ainfo.aid).split('_')[1])
    const parsedData = JSON.parse(pa)
    let pickupDetailsId = null
    let branchCreationFailed = false
    let branchErrorType = null
    
    // First, try to save pickup address
    try {
        const inputs = parsedData.inputs
        
        // Create branch/address
        const newAddress = {
            id: 0,
            province_id: inputs.pickup_province?.value || 0,
            city_id: inputs.pickup_city?.value || 0,
            barangay_id: inputs.pickup_barangay?.value || 0,
            street_building_num: inputs.street_name?.value || "",
            company_id: compID,
            user_id: userId,
            branch_code: inputs.pickup_branch_code?.value || "",
            branch_name: inputs.pickup_branch_name?.value || "",
            full_address: inputs.full_address?.value || ""
        }
        
        const branchRes = await rqx.post(`<<biz>>/${env()}/biz/branch/create`, newAddress)
        console.error("Branch error: ", branchRes)
        
        // Check for specific API errors
        if (branchRes === "code_exist") {
            branchCreationFailed = true
            branchErrorType = "code_exists"
            console.error('Branch code already exists')
        } else if (branchRes === "name_exist") {
            branchCreationFailed = true
            branchErrorType = "name_exists"
            console.error('Branch name already exists')
        } else if (branchRes && typeof branchRes === 'object' && branchRes.id) {
            // Success - create pickup details
            const pickupDetails = {
                company_branch_id: branchRes.id,
                area: inputs.area_name?.value || "",
                contact_number: inputs.pickup_num?.value || "",
                landmark: inputs.nearest?.value || "",
                pickup_time: inputs.pickup_datetime?.value || "",
                place_id: inputs.pickup_place_id?.value || "",
                is_default: 1, // First address is default
                user_id: userId,
                active: 1
            }
            
            const pickupDetailsRes = await rqx.post(`<<tool>>/${env()}/template/create_pickup_details`, pickupDetails)
            if (pickupDetailsRes && pickupDetailsRes.id) {
                pickupDetailsId = pickupDetailsRes.id
            }
        } else {
            // Unknown error
            branchCreationFailed = true
            branchErrorType = "unknown"
            console.error('Unknown error creating branch:', branchRes)
        }
    } catch (error) {
        branchCreationFailed = true
        branchErrorType = "exception"
        console.error('Exception creating pickup address:', error)
    }
    
    // If branch creation failed, return error without saving promo
    if (branchCreationFailed) {
        return { 
            message: 'error',
            error_type: branchErrorType,
            error_detail: branchErrorType === 'code_exists' ? 'Pickup warehouse code already exists' :
                         branchErrorType === 'name_exists' ? 'Pickup warehouse name already exists' :
                         'Failed to create pickup address. Please try again.'
        }
    }
    
    // Get pickup address details from parsed data
    const pickupAddress = parsedData.inputs.pickup_address?.value || ""
    const pickupProvince = parsedData.inputs.pickup_province?.value || ""
    const pickupCity = parsedData.inputs.pickup_city?.value || ""
    const pickupBarangay = parsedData.inputs.pickup_barangay?.value || ""
    
    const validatePickup = () => {
        const pickupOption = parsedData.inputs.pickup_option?.value
        if (pickupOption === '2') return 2
        else if (pickupOption === '3') return 3
        return 1
    }
    
    const body = {
        id: parsedData.pid,
        company_id: compID,
        package_name: parsedData.inputs.promo_caption.value,
        promo_name: parsedData.inputs.promo_name.value,
        start_date: moment(parsedData.inputs.start.value).format('YYYY-MM-DD'),
        end_date: moment(parsedData.inputs.end.value).format('YYYY-MM-DD'),
        user_id: userId,
        title: parsedData.inputs.title.value,
        designs: [{
            logo: parsedData.inputs.logo.link,
            featured_image: parsedData.inputs.ft_img.link,
            background_photo: parsedData.inputs.bg.link,
            price_bg: parsedData.inputs.price_bg?.value || ""
        }],
        link: parsedData.inputs.website.value,
        buttons: parsedData.inputs.button_caption.value,
        contact_number: parsedData.inputs.contact_num.value,
        fb_link: parsedData.inputs.facebook.value,
        promo_details: parsedData.inputs.promo_details.map((v) => v.value),
        rate: parsedData.inputs.reg_price.value.replace(/,(?=\d{3})/g, ''),
        discount: parsedData.inputs.discount_percent.value,
        total_rate: (parseFloat(parsedData.inputs.reg_price.value.replace(/,(?=\d{3})/g, '')) - (parseFloat(parsedData.inputs.reg_price.value.replace(/,(?=\d{3})/g, '')) * (parseFloat(parsedData.inputs.discount_percent.value) / 100))).toFixed(2),
        type: 1,
        status: parsedData.submit.type === 'Save' ? 1 : 2,
        shipping_type: parsedData.inputs.delivery.value && parsedData.inputs.pickup.value ? 3 : parsedData.inputs.delivery.value ? 1 : 2,
        category_id: parsedData.inputs.category.value,
        sub_category: parsedData.inputs.sub_category.value,
        free_shipping: parsedData.inputs.delivery_option.value === 'free_ship' ? 1 : 0,
        delivery_rate: parsedData.inputs.delivery_option.value === 'apply_set_del' ? 1 : 0,
        pickup_branch_name: parsedData.inputs.pickup_branch_name?.value || "",
        street_name: parsedData.inputs.street_name?.value || "",
        area_name: parsedData.inputs.area_name?.value || "",
        address: parsedData.inputs.full_address?.value || pickupAddress,
        pickup_city: pickupCity,
        pickup_province: pickupProvince,
        pickup_num: parsedData.inputs.pickup_num?.value || "",
        landmark: parsedData.inputs.nearest?.value || "",
        pickup_info: parsedData.inputs.pickup_datetime?.value || "",
        instagram_link: parsedData.inputs.instagram.value,
        promo_limit: parsedData.inputs.promo_limit?.value || "",
        text_promo: parsedData.inputs.text_promo?.value || "",
        accept_partial: parsedData.inputs.partial?.toggled ? 1 : 0,
        partial_amount: parsedData.inputs.partial?.toggled ? parsedData.inputs.partial.value : '',
        weight: Number(parsedData.inputs.weight?.value || 0),
        length: Number(parsedData.inputs.length?.value || 0),
        width: Number(parsedData.inputs.width?.value || 0),
        height: Number(parsedData.inputs.height?.value || 0),
        pickup_option: validatePickup(),
        barangay_id: pickupBarangay,
        pickup_details_id: pickupDetailsId
    }

    try {
        const res = await rqx.post(`<<tool>>/${env()}/template/create`, body)
        
        // Clean up localStorage after successful save - remove both promo and address data
        if (res.message === 'success') {
            // Remove promo data from localStorage
            localStorage.removeItem('cb_product')
            // Remove pickup address data from localStorage (if exists)
            localStorage.removeItem('pickup_address')
        }
        
        return res
    } catch (error) {
        console.error('Error saving promo:', error)
        return { message: 'error', error_detail: 'Failed to save promo' }
    }
}

export const RealPropertyUbr = async (compID, pa, ainfo) => {
    // console.log( JSON.parse(pa).styles)
    // return

    let fst = { location: JSON.parse(pa).styles.names.images.first_img.link} 
    let snd = { location: JSON.parse(pa).styles.names.images.second_img.link }
    let trd = { location: JSON.parse(pa).styles.names.images.third_img.link}
    let frt = { location: JSON.parse(pa).styles.names.images.fourth_img.link}
    let fft = { location: JSON.parse(pa).styles.names.images.fifth_img.link}
    let sxt = { location: JSON.parse(pa).styles.names.images.sixth_img.link}
    let own = { location: JSON.parse(pa).styles.names.images.owner_img.link}

    const p = {
        id: JSON.parse(pa).id,
        company_id: compID,
        name: JSON.parse(pa).name,
        status: JSON.parse(pa).submit.type,
        active: 1,
        url: `${domain('shp').url}/psl/sales_page/realproperty`,
        template_section_id: 1,
        template_id: 1,
        content: {
            contact_name: JSON.parse(pa).styles.names.contact_name.value,
            contact_number: JSON.parse(pa).styles.names.contact_number.value,
            facebook: JSON.parse(pa).styles.names.facebook.value,
            twitter: JSON.parse(pa).styles.names.twitter.value,
            instagram: JSON.parse(pa).styles.names.instagram.value,
            title: JSON.parse(pa).styles.names.title.value,
            title_description: JSON.parse(pa).styles.names.title_description.value,
            start_price: JSON.parse(pa).styles.names.start_price.value,
            price: JSON.parse(pa).styles.names.price.value,
            buttons: {
                first: { label: JSON.parse(pa).styles.names.buttons.first.label, link:JSON.parse(pa).styles.names.buttons.first.link },
                second: { label: JSON.parse(pa).styles.names.buttons.second.label, link: JSON.parse(pa).styles.names.buttons.second.link }
            },
            bestfor_title: JSON.parse(pa).styles.names.bestfor_title.value,
            bestfor_items: JSON.parse(pa).styles.names.bestfor_items.map((i) => {
                if (JSON.parse(pa).method === 'create') {
                    return i.value
                }
                return i.value
            }),
            feature_title: JSON.parse(pa).styles.names.feature_title.value,
            feature_items: JSON.parse(pa).styles.names.feature_items.map((i) => {
                if (JSON.parse(pa).method === 'create') {
                    return i.value
                }
                return i.value
            }),
            atp_title: JSON.parse(pa).styles.names.atp_title.value,
            atp_description: JSON.parse(pa).styles.names.atp_description.value,
            owner_name: JSON.parse(pa).styles.names.owner_name.value,
            owner_title: JSON.parse(pa).styles.names.owner_title.value,
            owner_description: JSON.parse(pa).styles.names.owner_description.value,
            contact_title: JSON.parse(pa).styles.names.contact_title.value,
            cellphone_num: JSON.parse(pa).styles.names.cellphone_num.value,
            telephone_num: JSON.parse(pa).styles.names.telephone_num.value,
            social_title: JSON.parse(pa).styles.names.social_title.value,
            images: {
                first_img: fst.location,
                second_img: snd.location,
                third_img: trd.location,
                fourth_img: frt.location,
                fifth_img: fft.location,
                sixth_img: sxt.location,
                owner_img: own.location,
            },
        },
        design: { fontColor: '#FFFFFF', fontSize: 14, font: 'Inter' },
        user_id: window.atob(ainfo.aid).split('_').pop(),
    }
    const s = await rqx.post(`<<tool>>/${env()}/realProperty/create`, p)
    return s

}
